<rx-intuitive-indication-buttons
	[indicationIds]="indicationIds"
	[selectedIndicationIds]="selectedIndicationIds"
	[enabledIndicationIds]="enabledIndicationIds"
	[disabled]="disabled"
	[hideIcon]="true"
	[asLabel]="asLabel"
	(indicationSelected)="indicationSelected.emit($event)"
>
	<ng-container *ngIf="!asLabel">
		<div class="vertical-separator" aria-hidden="true"></div>
		<rx-intuitive-remove-from-bridge-button (buttonClick)="onRemoveFromBridge()" [disabled]="!canRemove">
		</rx-intuitive-remove-from-bridge-button>
	</ng-container>
</rx-intuitive-indication-buttons>
